/**
 * Controls visibility of Group subscription entry points (e.g. Personal mega menu).
 * Set NUXT_PUBLIC_GROUP_SUBSCRIPTION_ENABLED=false to hide.
 * Default enabled when unset so existing deploys keep current behaviour.
 */
export const useIsGroupSubscriptionEnabled = (): boolean => {
	const value = String(
		useRuntimeConfig().public.GROUP_SUBSCRIPTION_ENABLED
	).toLowerCase()

	return value === '' || ['true', '1'].includes(value)
}
